module.exports = __webpack_public_path__ + "img/coffee.cb379975.svg";